// @ts-strict-ignore

import { Injectable } from '@angular/core';
import { DefaultProjectHelper } from '@project/helper/default-project.helper';
import { IResponsibleForProjectTypeHelper } from '@project/helper/i-project.helper';
import { ProjectType } from '@project/model/project-type';

@Injectable({ providedIn: 'root' })
export class SplicingConnectors221ProjectHelper extends DefaultProjectHelper implements IResponsibleForProjectTypeHelper  {
  public override isMoveArticleAllowed() {
    return false;
  }

  public isResponsible(projectType: ProjectType): boolean {
    return projectType === 'SPLICING_CONNECTOR_221';
  }
}
